<template>
  <div>
    <div class="page">
      <img src="./images/logo.png" alt="" class="logo" />
      <div class="text">有看投+</div>
      <!-- <img class="bg" src="./images/bj.png" /> -->
      <!-- <div class="footer">Copyright @ EMONEY.CN. All Rights Reserved</div> -->
      <div class="button" @click="downloadApp()">下载有看投+</div>
    </div>
    <div id="wechatTip" class="mask" style="display: none">
      <img class="arrow" src="./images/xian.png" alt="" />
      <div class="text2">
        <p>1. 请点击右上角</p>
        <p id="wechatText"></p>
      </div>
    </div>
  </div>
</template>

<script>
import appInfo from '@/assets/js/appInfo'
import { addStatistics } from '@/api/statistics'
export default {
  name: 'IndexPage',
  created() {
    this.downloadApp()
  },
  data() {
    return {
      origin: parseInt(appInfo.getParam('origin')) //1,2智盈30天未登录和从未登录，3加强版，4经典版
    }
  },
  computed: {},
  methods: {
    downloadApp() {
      var channelId = appInfo.getParam('channelid')

      if (appInfo.platform.Weixin) {
        var $wechatText = document.getElementById('wechatText')
        if (appInfo.platform.iOS) {
          $wechatText.innerText = '2. 选择在Safari中打开，即可下载'
        } else {
          $wechatText.innerText = '2. 选择在默认浏览器中打开，即可下载'
        }

        document.getElementById('wechatTip').style.display = 'block'
      } else if (appInfo.platform.iOS) {
        addStatistics({
          sourcePath: 'ykthtml_appdownload',
          extrainfo: JSON.stringify({
            title: 'appdownload',
            channelId: channelId,
            platform: 'iOS'
          })
        })
        location.href =
          'https://apps.apple.com/cn/app/%E6%9C%89%E7%9C%8B%E6%8A%95/id1062139675'
      } else {
        var url = 'https://yktstatic.emoney.cn/apk/ycstock.apk'

        addStatistics({
          sourcePath: 'ykthtml_appdownload',
          extrainfo: JSON.stringify({
            title: 'appdownload',
            channelId: channelId,
            platform: 'Android'
          })
        })

        if (channelId) {
          url = 'https://yktstatic.emoney.cn/apk/ycstock-' + channelId + '.apk'
        }

        location.href = url
      }
    }
  }
}
</script>

<style lang="scss" scoped>
body {
  background-color: #eef1f1;
  color: #3d3d3d;
  text-align: center;
}

a {
  color: #4690ef;
}

.page {
  line-height: 1.7;
  margin: 0 auto;
  font-size: 30px;
  background-color: #eef1f1;
  color: #3d3d3d;
  text-align: center;
}

.logo {
  display: block;
  width: 20%;
  margin: 200px auto 60px;
}

.text {
  color: #354052;
  font-weight: 700;
  font-size: 40px;
  height: 74px;
  line-height: 74px;
  text-align: center;
  padding-bottom: 200px;
}

.button {
  display: inline-block;
  width: 460px;
  line-height: 88px;
  margin: 0 auto;
  color: #ffffff;
  background: #8393f5;
  text-align: center;
  font-size: 28px;
  margin: 0 auto;
  border-radius: 44px;
}

.mask {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
}

.arrow {
  display: block;
  width: 90%;
  margin: 16px auto 0;
}

.text2 {
  padding: 20px 40px 0 100px;
  text-align: left;
  color: #ffffff;
  font-size: 32px;
  line-height: 48px;
}
</style>



// WEBPACK FOOTER //
// src/pages/IndexPage/IndexPage.vue